import React, { useState } from 'react';
import { bool, node, number, string } from 'prop-types';
import { uniqueId } from 'lodash';

import Toast from './Toast';
import ToastContext from './ToastContext';

const ToastProvider = ({ className, children, maxStack, preventDuplicate }) => {
  const [stack, setStack] = useState([]);

  const push = (type, content, options) => {
    if (preventDuplicate) {
      const isContentInStack = stack.some(
        item =>
          item.type === type &&
          JSON.stringify(item.content) === JSON.stringify(content)
      );

      if (isContentInStack) {
        return;
      }
    }

    const id = uniqueId('toast_');
    setStack(prevStack => {
      if (prevStack.length === maxStack) {
        prevStack.shift();
      }

      return [
        ...prevStack,
        {
          id,
          type,
          content,
          duration: options?.duration || 5000,
          action: options?.action || <></>
        }
      ];
    });

    setTimeout(() => {
      setStack(prevState => prevState.filter(prevItem => prevItem.id !== id));
    }, options?.duration || 5000);
  };

  const closeAll = () => {
    setStack([]);
  };

  return (
    <ToastContext.Provider value={{ push, closeAll }}>
      {children}
      <Toast className={className} stack={stack} setStack={setStack} />
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  className: string,
  children: node,
  maxStack: number,
  preventDuplicate: bool
};

ToastProvider.defaultProps = {
  className: null,
  children: null,
  maxStack: 5,
  preventDuplicate: false
};

export default ToastProvider;
